import { Box, Button, styled, Typography, useTheme } from '@mui/material';
import Mousetrap from 'mousetrap';

import { ShortcutText } from 'src/components/ShortcutText/shortcut-text';
import { appShortcuts } from 'src/constants/appShortcuts';
import { useScreenDimensions } from 'src/utils/system';

const QuickActionsText = styled(Typography)(({ theme }) => ({
  whiteSpace: 'nowrap',
  fontWeight: '700',
  fontSize: '0.85rem',
  transition: 'inherit',
  color: theme.palette.custom.OV.sys.onSurfaceVariant,
  textTransform: 'none',
  flexGrow: 1,
  textAlign: 'left',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const QuickActionsButton = () => {
  const theme = useTheme();
  const { isMobile } = useScreenDimensions();
  return (
    <Button
      disableRipple
      onClick={() => Mousetrap.trigger(appShortcuts.quickActions.command)}
      variant="text"
      size="small"
      sx={{
        height: '2.25rem',
        borderRadius: '0.75rem',
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: '1rem',
        paddingRight: '1rem',
        flexGrow: 1,
        color: theme.palette.custom.OV.sys.onSurfaceVariant,
        backgroundColor: theme.palette.custom.OV.sys.surfaceContainer,
      }}
    >
      <QuickActionsText variant="subtitle1">
        <Box flexGrow={1} component="span">
          Quick Actions
        </Box>
        {!isMobile && (
          <ShortcutText shortcut={appShortcuts.quickActions.command} size="medium" />
        )}
      </QuickActionsText>
    </Button>
  );
};
